var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr'),_c('div',{staticClass:"list"},[_c('div',{staticClass:"content"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"list-item"},[_vm._t("default",null,null,item)],2)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }